module.exports = __webpack_public_path__ + "img/internet.ecd15bcc.svg";